var Store = function(options){
    this.settings = $.extend({}, this.defaults, options);
    this.init();
};

Store.prototype = {
    // shorthand for using prototype
    constructor : Store,
    // default options
    defaults : {},
    productDetailsModal : {},
    _cached_details : {},
    _basket : {},
    _currentBundle : {},
    _stockOptions : [],
    _currentProduct : {},
    _cache_queue : [],
    _activeEdit : false,

    // flag used for preventing duplicate form submissions
    processing : false,
    storeCheckoutForm : document.getElementById("store-checkout-form"),
    storeCheckoutFormId : "store-checkout-form",

    init : function(){
        var _this = this;
        const $storeForm = $("#store-checkout-form");
        const $shippingSelect = $storeForm.find(".js-shipping-options");

        $('#store-checkout-form').validate();

        // set auction flag based on form type enum
        _this.is_auction = !!(QGIV.Form.type == 'auction');

        _this.productDetailsModal = $('#product-details').modal({
            bgClose: true,
            disableTrigger: true,
            width: 'product-details-modal',
            onClose : function(){
                _this.activeEdit = false;
                $('body').removeClass('modal-open');
            },
            afterCloseModal : function() {
                $('.product-gallery').data('Swipe').kill();
                // reset the quantity for the next product
                AutoNumeric.getAutoNumericElement(document.getElementById('product-qty')).set(0);
            }
        });

        // Script to Populate the Modal with the right product details
        $('.modal-trigger').click(function(e){
            e.preventDefault();

            $('.product-qty-field', _this.productDetailsModal).addClass('hide-content');
            $('.product-add-to-cart', _this.productDetailsModal).addClass('hide-content');

            _this._currentBundle = product_cache[$(this).attr('data-id')];
            _this.populateDetails(_this._currentBundle);

            $('.product-gallery .thumbnails li:first-child').click();

            // This class is removed in the 'onClose' func
            $('body').addClass('modal-open');

            // Remove existing error message
            $('#product-details .ui-message').remove();

            return false;
        });

        // Setup image gallery
        if (
            $.fn.gallery &&
            $(".product-details-modal .product-gallery").length > 0
        ) {
            $(".product-details-modal .product-gallery").gallery({
                type: "gallery",
            });
        }

        // bind numeric input
        if ( $('.ui-numeric-text').length ) {
            $('.ui-numeric-text').numericInput();
        }

        // If the payment iframe has been added to the DOM, start sending the
        // handshake that is needed to confirm we can communicate with it
        if ($('#payment-iframe').length) {
            QGIV.StorePaymentIframe.startPollingPaymentIframeForHandshake();
        }

        // Payment iframe resize event listener. Because no loading animation
        // was added to this implementation, we do not need to add logic to
        // replace the loading animation here.
        window.addEventListener("message", (message) => {
            if (message.source !== QGIV.StorePaymentIframe.contentWindow) {
                return; // Skip message in this event listener
            }

            const parsedData =
                QGIV.StorePaymentIframe.getParsedDataFromPostMessage(message);

            if (
                parsedData.event ===
                QGIV.StorePaymentIframe.paymentIframeHandshakeEvent
            ) {
                QGIV.StorePaymentIframe.handleHandshakeMessage();
            }

            if (
                parsedData.event ===
                QGIV.StorePaymentIframe.paymentIframeResizeEvent
            ) {
                QGIV.StorePaymentIframe.handleResizeMessage(parsedData);
            }
        });

        // Payment iframe form submission listener, added only if the credit card iframe is visible on the store checkout page
        // This allows the native html form submission to be prevented and handled by the iframe
        if (
            $("#payment-fields-credit-card").length &&
            _this.storeCheckoutForm
        ) {
            _this.storeCheckoutForm?.addEventListener(
                "submit",
                function (event) {
                    const creditCardIframeSelected = !!(
                        $("#payment-type-credit-card").is(":checked") &&
                        QGIV.usePaymentIframe
                    );

                    // Account for Zero Dollar Transaction. Technically the Payment Iframe exists on the DOM, it is just hidden
                    // by CSS when the transaction is free.
                    const transactionTotalCost = $(
                        "#registration-total [data-total-cost]",
                    ).attr("data-total-cost");
                    const zeroDollarTransaction =
                        !transactionTotalCost || transactionTotalCost === "0";

                    // Handle the form data

                    // Exit early and return to normal form submission if iframe credit card is not selected or there is
                    // no total
                    if (!creditCardIframeSelected || zeroDollarTransaction) {
                        return;
                    }

                    // Prevent the default form submission in order to handle the form submission with the iframe
                    event.preventDefault();

                    // Handle the form submission with the iframe
                    QGIV.StorePaymentIframe.getShouldContinueToFormSubmission()
                        .then((shouldContinueToFormSubmission) => {
                            if (shouldContinueToFormSubmission) {
                                // trigger continuation of form submission
                                document.forms[
                                    _this.storeCheckoutFormId
                                ].submit();
                            } else {
                                Message.target = `#${_this.storeCheckoutFormId}`;
                                Message.post(
                                    QGIV.StorePaymentIframe
                                        .creditCardIframeErrors,
                                    "error",
                                );
                                _this.processing = false;

                                const loadingModal =
                                    $("#loading-modal").data("qg_modal");
                                loadingModal.closeModal();

                                // Update the text of the submit button back to normal
                                $(".js-submit-donation-button")?.find("span").text("Complete Purchase");

                                QGIV.StorePaymentIframe.creditCardIframeErrors.length = 0;
                            }
                        })
                        .catch((errors) => {
                            QGIV.StorePaymentIframe.creditCardIframeErrors =
                                errors;
                        });
                },
            );
        }


        // PayPal authentication
        // we need to make sure we're on the store checkout page before initializing since this file is shared with registration
        if ( typeof QGIV.PayPal !== 'undefined' && $('#store-checkout-form').length ) {
            QGIV.PayPal.onBeforeOpen = function($button){
                var transactionTotal = parseFloat($('#registration-total [data-total-cost]').attr('data-total-cost').replace(/\,/g, '')),
                    $shipping = $('.js-shipping-options'),
                    shipping = $shipping.val();

                // make sure we have a shipping option selected
                if ( $shipping.length & ! shipping ) {
                    Message.target = '#store-checkout-form';
                    Message.post('Please select a shipping option', 'error');

                    this.validated = false;
                } else {
                    // make sure we have a valid amount
                    if ( transactionTotal > 0 ) {
                        // grab transaction amount
                        this.path += '&amount=' + transactionTotal;
                        this.authorizedAmount = transactionTotal;

                        // we've got what we need, make sure the session is validated
                        this.validated = true;
                    } else {
                        this.validated = false;
                    }
                }
            };

            QGIV.PayPal.init();
        }

        // Functions for processing transactions via legacy P2P store with
        // new PayPal API
        if (QGIV.PayPalSdk?.isEnabled && $("#store-checkout-form").length) {
            /**
             * @function getCreateOrderData
             * @description Builds a post string from form inputs and stores it
             *      on the PayPal SDK namespace
             * @returns {jQuery.deferred.promise} Promise used for chaining
             */
            const getCreateOrderData = () => {
                const postString = buildPostString($("#store-checkout-form"));
                const totalString = `&total=${_this.updateTotals()}`;
                const dfd = $.Deferred();

                if ($shippingSelect.length && $shippingSelect.val() === "") {
                    Message.target = "#store-checkout-form";
                    Message.post("Please select a shipping option", "error");

                    dfd.reject();
                    return dfd.promise();
                }

                QGIV.PayPalSdk.postString = `${postString}${totalString}`;

                dfd.resolve();
                return dfd.promise();
            };

            QGIV.PayPalSdk.$container = $storeForm.find(
                ".js-authenticate-paypal-container",
            );
            QGIV.PayPalSdk.getCreateOrderData = getCreateOrderData;
        }

        // Apple Pay setup
        if ( typeof QGIV.ApplePay !== 'undefined' && $('#store-checkout-form').length ) {
            QGIV.ApplePay.onBeforeOpen = function($button){
                var $transactionSummary = $('.js-purchase-total');
                var subtotal = $transactionSummary.attr('data-cart-total');
                var shipping = $transactionSummary.attr('data-shipping-total');
                var tax = $transactionSummary.attr('data-tax-total');
                var transactionTotal = QGIV.Utilities.toFloat($transactionSummary.attr('data-total'));
                var $shipping = $('.js-shipping-options');
                var request = {};

                // make sure we have a shipping option selected
                if ( $shipping.length & ! shipping ) {
                    Message.target = '#store-checkout-form';
                    Message.post('Please select a shipping option', 'error');

                    this.validated = false;

                } else {
                    // make sure we have a valid amount
                    if ( transactionTotal > 0 ) {

                        // storage for line items
                        request.lineItems = [];

                        // subtotal
                        request.lineItems.push({
                            'label' : 'Subtotal',
                            'amount': subtotal
                        });

                        // shipping
                        if ( QGIV.Utilities.toFloat(shipping) > 0 ) {
                            request.lineItems.push({
                                'label' : 'Shipping',
                                'amount': shipping
                            });
                        }

                        // tax
                        if ( QGIV.Utilities.toFloat(tax) > 0 ) {
                            request.lineItems.push({
                                'label' : 'Tax',
                                'amount': tax
                            });
                        }

                        request.total = { label : 'Total', amount : transactionTotal };

                        QGIV.PaymentRequest = $.extend({}, QGIV.PaymentRequest, request);

                        // we've got what we need, make sure the session is validated
                        this.validated = true;
                    } else {
                        this.validated = false;
                    }
                }
            };

            QGIV.ApplePay.onPaymentAuthorized = function(response){
                // analytics tracking for people who use Apple Pay
                QGIV.Analytics.GA.send({
                    hitType : 'event',
                    eventCategory : 'Donation Form',
                    eventAction : 'paid',
                    eventLabel : 'Apple Pay'
                });

                $('.js-submit-donation-button').click();
            };

            QGIV.ApplePay.init();
        }
        $('.add-product-to-cart', _this.productDetailsModal).on('click', function(){
            if (_this.is_auction) {
                _this.updateQtySelect();
            } else {
                _this.addItemToCart();
            }
            return false;
        });

        $(document.body).on('click', '.delete-cart-item', function(){
            _this.deleteCartItem($(this).closest('.cart-item-tile').attr('data-id'));

            return false;
        });

        $(document.body).on('click', '.edit-cart-item', function(){
            _this.activeEdit = ($(this).closest('.cart-item-tile'));
            _this._currentBundle = product_cache[_this.activeEdit.attr('data-bundleid')];
            _this.populateDetails(_this._currentBundle);

            return false;
        });

        $(document.body).on('change', '.product-option-select', function(){
            $('option[value="choose-one"]', $(this)).remove();
            $('.product-qty-field', _this.productDetailsModal).addClass('hide-content');
            $('.product-add-to-cart', _this.productDetailsModal).addClass('hide-content');

            var parent = $(this).closest('.product-option-container');

            $('.product-opt-grid .product-option-container:gt('+parent.index()+')').addClass('hide-content');

            var _next = parent.next('.product-option-container');

            if (_next.length) {
                _this.buildSelectOptions(_next);
                _next.removeClass('hide-content');
            } else {
                // all options have been toggled
                _this.checkStock();
            }
        });

        $('.ui-popup-container').on('popupHidden', function(){
            $('.popup-shopping-cart .ui-message').remove();
        });

        // Shipping Option Select
        $('.shipping-options').on('change', function (){
            _this.updateTotals();
        });

        $('.update-cart').on('click', function(){
            _this.updateCart();
        });

        if ( $('.shopping-cart-table').length ) {
            _this.updateTotals();
        }

        if ( $('#shipping-is-same').length ) {
            $('#shipping-is-same').on('change', function(){
                if ( $(this).is(':checked') ) {
                    $('#registration-shipping-fields').addClass('hide-content');
                } else {
                    $('#registration-shipping-fields').removeClass('hide-content');
                }
            });
        }

        // Uses same partial as donations...
        if ( $('#loading-modal').length > 0 ){
            var loadingModal = $('#loading-modal').modal({
                bgClose : false,
                disableTrigger : true,
                width : 'auto-width'
            });
        }

           // bind form submission
        $("#store-checkout-form").on("submit", function (e) {
            const $form = $(e.target);
            const $submitButton = $form.find(".submit-donation");
            const $shipping = $(".js-shipping-options");
            const shipping = $shipping.val();
            const loadingModal = $("#loading-modal").data("qg_modal");
            const errors = [];

            const creditCardIframeSelected = !!(
                $("#payment-type-credit-card").is(":checked") &&
                QGIV.usePaymentIframe
            );

            // check for errors in the credit card iframe and add them to the error array
            if (
                QGIV.StorePaymentIframe.creditCardIframeErrors.length &&
                creditCardIframeSelected
            ) {
                errors.push(...QGIV.StorePaymentIframe.creditCardIframeErrors);
            }

            // indicate that we are currently processing
            if (_this.processing) {
                e.preventDefault();
                return;
            }
            _this.processing = true;

            // store purchase recipient validation
            if (
                $('.js-no-donation-recipient[data-required="true"]').length > 0
            ) {
                if (
                    $('input[name="donation_type"]').val() === "event_donation"
                ) {
                    errors.push("Please select a purchase recipient");
                    if (creditCardIframeSelected) {
                        QGIV.StorePaymentIframe.creditCardIframeErrors.push(
                            "Please select a purchase recipient",
                        );
                    }
                }
            }

            // make sure front-end validation is taken care of
            // Payment iframe validation is handled in the iframe
            if ($shipping.length && !shipping && !creditCardIframeSelected) {
                errors.push("Please select a shipping option");
            }

            if (errors.length) {
                Message.target = "#store-checkout-form";
                Message.post(errors, "error");
                _this.processing = false;

                e.preventDefault();
                return;
            }

            // no errors, proceed with submitting the form, change text not val as val is used in the post, no need to disable as we are using the processing flag
            $submitButton.find("span").text("Processing Purchase...");

            // show the loading modal
            if (typeof loadingModal !== "undefined") loadingModal.showModal();
        });

        UI.truncate( '.cart-item-tile .product-description', 150 );
        UI.truncate( '.ui-tile .product-details', 125 );

        // loading modal
        if ( $('#donation-recipient-modal').length ){
            // move the modal out of the donation form
            // becuase hitting enter in IE tries to submit
            $('#donation-recipient-modal').appendTo('body');

            // after the move, initialize
            $('#donation-recipient-modal').modal({
                disableTrigger : true,
                bgClose : true,
                width : $('#donation-recipient-modal').attr('data-width'),
                afterCloseModal : function() {
                    _this.resetEntitySearchModal();
                }
            });

            _this.donationRecipientModal = $('#donation-recipient-modal').data('qg_modal');
        }

        $('.js-change-donation-recipient').on('click', function(e) {
            e.preventDefault();

            _this.donationRecipientModal.showModal();
            $('#search-donation-recipients').focus();

            if ( SystemSearch && ! _this.searchReady ) {
                _this.initDonationSearch();
                _this.searchReady = true;
            }

            if ( _this.searchReady ) {
                _this.donationRecipientSearch.triggerSearch();
            }
        });

        _this.initDonationSearch();

    },

    populateDetails : function(product){
        $('.grid.tight-grid').empty();

        var _this = this;
        var	productCost = _this.getBasePrice(product);
        var $singleImage = $('.single-product-image');
        var $gallery = $('.product-gallery');
        var $icon = $('.no-product-images');
        var autoNumeric = undefined;

        // Base Product Info
        $('.product-cost', _this.productDetailsModal).text( productCost + ' ea.');
        $('.product-title-text', _this.productDetailsModal).text(product.title);
        $('.product-description', _this.productDetailsModal).html(product.description);
        // hide and remove all existing images
        $singleImage.addClass('hide-content').empty();
        $gallery.addClass('hide-content').find('.thumbnails, .main-image').empty();
        $icon.addClass('hide-content');

        // Set Up Images
        if ( product.images.length === 1 && product.images[0].src ) {

            // update image and show
            $image = $('<img src="' + product.images[0].src + '" alt="Image for ' + product.title + '" />')
            $singleImage.append($image).removeClass('hide-content');

        } else if ( product.images.length > 1 ) {

            // loop through images and add image and thumbnail
            for ( var index in product.images ) {
                var imageNumber = parseInt(index) + 1;
                $gallery.find('.thumbnails').append('<li><a href="#" class="thumbnail"><img src="' + product.images[index].src + '" alt="Image ' + imageNumber + ' for ' + product.title + '" /></a></li>');
                $gallery.find('.main-image').append('<div class="image-slide js-gallery-slide"><img class="width-100 js-gallery-slide-media" src="' + product.images[index].src + '" alt="Image ' + imageNumber + ' for ' + product.title + '" /></div>');
            }
            if ( ! $gallery.find('.thumbnails li:first-child').hasClass('active') ) {
                $gallery.find('.thumbnails li:first-child').addClass('active ui-border-primary-color');
            }

            // get the height of the new gallery
            var firstImage = $('.product-gallery .main-image .js-gallery-slide:first-child .js-gallery-slide-media');
            if (firstImage.height() < 1) {
                setTimeout(function() {
                    var height = firstImage.height();
                    $gallery.find('.main-image').height(height);
                    $gallery.find('.main-image .js-gallery-slide:first-child').height(height);
                    $gallery.find('.gallery-arrow').height(height);
                }, 300);
            } else {
                var height = firstImage.height();
                $gallery.find('.main-image').height(height);
                $gallery.find('.main-image .js-gallery-slide:first-child').height(height);
                $gallery.find('.gallery-arrow').height(height);
            }

            // show gallery
            $gallery.removeClass('hide-content');

            // Init Slider
            setTimeout(() => {
                $gallery.data("Swipe").setup();
            }, 100);

        } else {

            // show and set icon
            $icon.removeClass('hide-content')
                .find('.store-icon').removeClass().addClass( 'store-icon ' + product.icon );

        }

        // Handle Descriptions
        if ( product.description === ' ' || product.description.length === 0 ) {
            $('.product-description', _this.productDetailsModal).closest('.content-box').addClass('hide-content');
        } else {
            $('.product-description', _this.productDetailsModal).closest('.content-box').removeClass('hide-content');
        }

        var first = true;

            if ( product.fields.length ) {
                for ( var ind in product.fields ) {
                    var field = product.fields[ind];

                    if ( typeof field === 'object' ) {
                        var opt_container = $('.option-template', _this.productDetailsModal).clone();
                        opt_container.removeClass('option-template');

                        if ( first ) {
                        opt_container.removeClass('hide-content');
                    }

                    opt_container.find('.product-option-select').attr('data-textlabel', field.text);
                    opt_container.find('.product-option-select').attr('data-fieldid', field.id);

                    if ( first ) {
                        _this.buildSelectOptions(opt_container);
                    }

                    $('.product-opt-grid').append(opt_container);

                        first = false;
                    }
                }
            } else {
                if ( parseInt(product.hasAttributes*1) ) {
                    _this._currentProduct = product.fieldData[0];
                } else {
                    _this._currentProduct = product;
                }

                if ( parseInt(_this._currentProduct.unlimited*1) || (_this._currentProduct.qtyAvail > 0 ) ) {
                if ( ! _this.activeEdit ) {
                    $('.product-qty', _this.productDetailsModal).val(0);
                }
                // convert to numbers and booleans for clear evaluations
                var isUnlimitedQtyAvailable = _this._currentProduct.unlimited === '1';
                var qtyAvailable = parseInt(_this._currentProduct.qtyAvail);
                var purchaseLimit = parseInt(_this._currentProduct.purchaseLimit);
                var hasPurchaseLimit = purchaseLimit > 0;
                const defaultOptionCount = 9999;

                // set qty available to 9999 to prevent crashes
                if (qtyAvailable > defaultOptionCount) {
                    qtyAvailable = defaultOptionCount;
                }

                // set the limit for the product qty input
                if ( isUnlimitedQtyAvailable ) {
                    if ( hasPurchaseLimit ) { // use purchase limit
                        $('.product-qty', _this.productDetailsModal).attr('data-v-max', purchaseLimit);
                    } else { // no limits
                        // setting the max to a larger number (9999), since this is an input it does not crash the same way
                        // auctions select does when a large product quantity is set.  This number is arbitrarily set and may
                        // be changed if needed.
                        $('.product-qty', _this.productDetailsModal).attr('data-v-max', defaultOptionCount);
                    }
                } else {
                    if ( hasPurchaseLimit && purchaseLimit < qtyAvailable ) { // use purchase limit as it is in use and lowest
                        $('.product-qty', _this.productDetailsModal).attr('data-v-max', purchaseLimit);
                    } else { // use quantity available
                        $('.product-qty', _this.productDetailsModal).attr('data-v-max', qtyAvailable);
                    }
                }

                // update the max value of product quantity's AutoNumeric plugin
                if ( $('.product-qty', _this.productDetailsModal).attr('data-v-max') ) {
                    autoNumeric = AutoNumeric.getAutoNumericElement(document.getElementById('product-qty')).set(0).update({
                        minimumValue: 0,
                        maximumValue: parseInt($('#product-qty').attr('data-v-max'))
                    });
                }

                var productCost = _this.getBasePrice(_this._currentProduct);

                $('.product-cost', _this.productDetailsModal).text( productCost + ' ea.');
                $('.product-qty-field', _this.productDetailsModal).removeClass('hide-content');
                $('.product-add-to-cart', _this.productDetailsModal).removeClass('hide-content');
            } else {
                $('.product-qty-field', _this.productDetailsModal).addClass('hide-content');
                $('.product-add-to-cart', _this.productDetailsModal).addClass('hide-content');
                $('.product-cost', _this.productDetailsModal).text('SOLD OUT');
            }
        }

        // Make sure we're at the top of the container
        $('.product-body').scrollTop(0);

        _this.productDetailsModal.data('qg_modal').showModal();

            if ( _this.activeEdit ) {
                $('.product-opt-grid .product-option-select').each(function(){
                if ( _this.activeEdit.attr('data-attr' + $(this).attr('data-fieldid')) ) {
                    $(this).val(_this.activeEdit.attr('data-attr' + $(this).attr('data-fieldid')));
                    $(this).show().change();
                }
            });
            $('.product-qty', _this.productDetailsModal).val(_this.activeEdit.attr('data-qty'));
            } else if (_this.is_auction) {
                var $select = $('.item-' + _this._currentProduct.id + '-qty');

            if ($select.length) {
                // if autonumeric was initialized, we'll update the value there to prevent it being out of sync
                if ( autoNumeric ) {
                    autoNumeric.set($select.val());
                } else {
                    $('.product-qty', _this.productDetailsModal).val($select.val());
                }
            }
            }
    },

    buildSelectOptions : function(container) {
        var _this = this,
            label = container.find('select').attr('data-textlabel'),
            p_opts = [],
            opts = [];

        // determine which attribute we're currently presenting
        var index = 0;
        for ( var ind in _this._currentBundle.fields ) {
            var fld = _this._currentBundle.fields[ind];

            if ( fld.text === label ) {
                index = ind;
                break;
            }
        }

        // cache the current batch of stock options
        var _stockOpts = _this._currentBundle.fieldData;
        var _filteredStockOpts = [];
        var previousVal = false;
        if ( index > 0 ) {
            // this is an additional attribute. we need to grab the currently filtered list of stock
            // options, and begin filtering those
            _stockOpts = _this._stockOptions[index-1];
            previousVal = $('.product-opt-grid .product-option-select:eq('+(index-1).toString()+')').val();
            previousLabel = $('.product-opt-grid .product-option-select:eq('+(index-1).toString()+')').attr('data-textlabel');
        }

        // iterate over the stock options, building the list of available dropdown choices based
        // what products have stock
        for ( ind = 0; ind < _stockOpts.length; ind++ ) {
            var stockedProduct = _stockOpts[ind];
            var flds = stockedProduct.fields;

            if ( flds && flds[label] ) {
                if ( !previousVal || (previousVal && flds[previousLabel] === previousVal) ){
                    _filteredStockOpts.push(stockedProduct);

                    if ( $.inArray(flds[label], p_opts) === -1 ) {
                        p_opts.push(flds[label]);
                    }
                }
            }
        }

        // need to sort the fields
        var fs = _this._currentBundle.fields[index].data;

        if ( fs && fs.length ) {
            for ( var f_ind = 0; f_ind < fs.length; f_ind++ ) {
                if ( $.inArray(fs[f_ind], p_opts) != -1 ) {
                    opts.push(fs[f_ind]);
                }
            }
        }

        _this._stockOptions[index] = _filteredStockOpts;

        if ( opts.length ) {
            container.find('select').empty();
            container.find('select').append('<option value="choose-one">' + label + "</option>");

            for ( var ind = 0; ind < opts.length; ind++ ) {
                var disabled = ((opts[ind].indexOf("(sold out)") != -1) ? " disabled" : "");
                container.find('select').append('<option value="'+opts[ind]+'" '+disabled+'>' + opts[ind] + "</option>");
            }
        } else {
            // sold out
            $('.product-cost', _this.productDetailsModal).text('SOLD OUT');
        }
    },

    checkStock : function(){
        var _this = this,
            _queued_prod = {};

        if ( _this._currentBundle.hasAttributes ) {
            for (var ind in _this._currentBundle.fieldData) {
                var winner = true;

                $('.product-option-select:visible', _this.productDetailsModal).each(function(){
                    if ( _this._currentBundle.fieldData[ind]["fields"][$(this).attr('data-textlabel')] !== $(this).val() ) {
                        winner = false;
                    }
                });

                if ( winner ) {
                    _queued_prod = _this._currentBundle.fieldData[ind];
                    break;
                }
            }
        } else {
            _queued_prod = _this._currentBundle;
        }

        if ( _queued_prod ) {
            _this._currentProduct = _queued_prod;

            if ( _queued_prod.unlimited || (_queued_prod.qtyAvail > 0) ) {
                if ( !_this.activeEdit ) {
                    $('.product-qty', _this.productDetailsModal).val(0);
                }
                if ( !_queued_prod.unlimited && (_queued_prod.qtyAvail < _queued_prod.purchaseLimit) ) {
                    $('.product-qty', _this.productDetailsModal).attr('data-v-max', _queued_prod.qtyAvail);
                } else {
                    if ( _queued_prod.purchaseLimit > 0 ) {
                        $('.product-qty', _this.productDetailsModal).attr('data-v-max', _queued_prod.purchaseLimit);
                    } else {
                        $('.product-qty', _this.productDetailsModal).removeAttr('data-v-max');
                    }
                }

                var productCost = _this.getBasePrice(_queued_prod);

                $('.product-cost', _this.productDetailsModal).text( productCost + ' ea.');
                $('.product-qty-field', _this.productDetailsModal).removeClass('hide-content');
                $('.product-add-to-cart', _this.productDetailsModal).removeClass('hide-content');
            } else {
                $('.product-qty-field', _this.productDetailsModal).addClass('hide-content');
                $('.product-add-to-cart', _this.productDetailsModal).addClass('hide-content');
                $('.product-cost', _this.productDetailsModal).text('SOLD OUT');
            }
        }
    },

    updateTotals : function() {
        var _this = this;

        var subtotal = $('.subtotal-amount').text().replace(/[^0-9.]/g, "") || '0.00',
            shipping = 0,
            total = parseFloat(subtotal) + parseFloat(tax) + parseFloat(shipping),
            $selectedOpt = $('.shipping-options').find(':selected');
        const $shippingSelect = $(".js-shipping-options");

        if ( $('.shipping-options').length && $selectedOpt.attr('data-cost') ) {
            shipping = $selectedOpt.attr('data-cost').replace(/[^0-9.]/g, "") || '0.00';
        }

        if ( shipping > 0 ) {
            $('.shipping-amount')
                .find('.appearance-disabled').addClass('hide-content').end()
                .find('.shipping-value').removeClass('hide-content').text('$'+shipping.toString());
        } else {
            $('.shipping-amount')
                .find('.appearance-disabled').removeClass('hide-content').end()
                .find('.shipping-value').addClass('hide-content').text('$'+shipping.toString());
        }

        $('.js-purchase-total').attr('data-shipping-total', shipping);

        total = parseFloat(subtotal) + parseFloat(shipping);

        if ( $('.tax-amount').length > 0 ) {
            var tax = (total * parseFloat($('.tax-amount').attr('data-rate')));
        } else {
            var tax = 0;
        }

        total += tax;
        total = Math.round(total * 100) / 100;

        // product total
        $('h4.total-amount span').text(_this.currencyFormat(total));
        $('.tax-amount span').text(_this.currencyFormat(tax));
        $('.js-registration-summary-total').attr('data-purchase-total', total);

        newTotal = oldTotal = total;

        if ( newTotal === 0 ) {
            $('.js-hide-payment-info').addClass("hide-content");
        } else {
            $('.js-hide-payment-info').removeClass("hide-content");
        }

        if ( $('#registrant-table').length > 0 ) {
            $('#registrant-table .reg-total').each(function(){
                newTotal += parseFloat($(this).text().replace(/[^0-9.]/g, "") || '0.00');
            });

            $('#registrant-table .old-price').each(function(){
                oldTotal += parseFloat($(this).text().replace(/[^0-9.]/g, "") || '0.00');
            });
        }

        if ( $('#old-registration-total').length ) {
            $('#old-registration-total').text(_this.currencyFormat(oldTotal));
            //$('#old-registration-total').attr('data-total-cost', _this.currencyFormat(oldTotal));
        }
        // overall total
        $('span.total-amount span').text(_this.currencyFormat(newTotal));
        $('span.total-amount span').attr('data-total-cost', newTotal);
        $('.js-registration-summary-total, .js-purchase-total').attr('data-total', newTotal);

        // check if we need to re-authorize PayPal tokens
        var transactionTotalCost = $('#registration-total [data-total-cost]').attr('data-total-cost');
        if ( typeof QGIV.PayPal !== 'undefined' && (typeof transactionTotalCost !== typeof undefined && transactionTotalCost !== false) ) {
            var transactionTotal = parseFloat(transactionTotalCost.replace(/\,/g, ''));
            QGIV.PayPal.validateAuthorizedAmount(transactionTotal);
        }

        // There is not a good way to check if the various line items we send to
        // PayPal have changed, so we need to deauthorize every time we
        // recalculate the totals.
        if (QGIV.PayPalSdk?.isEnabled) {
            QGIV.PayPalSdk?.deauthorize();

            // if using PayPal SDK, disable/enable PayPal buttons based on amount
            if (
                newTotal === 0 ||
                ($shippingSelect.length && $shippingSelect.val() === "") ||
                $("html").hasClass("cms-enabled")
            ) {
                QGIV.PayPalSdk?.disableButtons();
            } else {
                QGIV.PayPalSdk?.enableButtons();
            }
        }

        // Products with a value of $0.00 can be added to a $0 registration
        // Those products can have a non $0 shipping option which makes the registration no longer a $0 registration
        // Running an eval on newTotal to hide/show the display of payment options based on if needed
        var $registrationTimelineElement = $(".registration-total-timeline-item");
        if (newTotal > 0 && $registrationTimelineElement.hasClass("hide-content")) {
            $registrationTimelineElement.removeClass("hide-content");
        } else if (newTotal === 0 && !$registrationTimelineElement.hasClass("hide-content")) {
            $registrationTimelineElement.addClass("hide-content");
        };

        return newTotal;
    },

    updateQtySelect : function() {
        var _this = this;
        var qty = $('.product-qty', _this.productDetailsModal).val() || 0;
        var $select = $('.item-' + _this._currentProduct.id + '-qty');

        if ($select.length) {
            $select.val(qty).trigger('change');
        }

        _this.productDetailsModal.data('qg_modal').closeModal();
        _this._currentProduct = {};
        _this._currentBundle = {};
    },

    addItemToCart : function() {
        $('.item-popup .ui-message').remove();

        var _this = this;
        var qtyInput = $('.product-qty', _this.productDetailsModal);

        if ( qtyInput.val() && parseInt(qtyInput.val()) ) {
            var postString = "&action=add-to-cart&productId=" + _this._currentProduct.id + '&qty=' + qtyInput.val();

            if ( _this.activeEdit ) {
                postString += "&activeEdit=" + _this.activeEdit.attr('data-id');
            }

            if ( window.location.href.indexOf('register') != -1 ) {
                postString += "&fromReg=1";
            }

            // indicate that we are currently processing
            if ( _this.processing ) return;
            _this.processing = true;

            $.fn.qpost({
                url : url('store_front', [$('input[name="form"]').val()]),
                csrf : true,
                type : "POST",
                data : postString,
                dataType : "json",
                success : function(data){
                    if ( data && data.item ) {
                        var cartItem = $('.popup-shopping-cart .default-cart-item').clone();
                        var cost = _this.formatFormCurrency(data.item.cost);

                        cartItem.removeClass('hide-content').removeClass('default-cart-item').addClass('ui-highlight-color');

                        if ( data.item.images && data.item.images.length > 0 ) {
                            $('.cart-item-image', cartItem).attr('src', data.item.images[0].src);
                        } else {
                            $('.cart-item-image', cartItem).hide();
                            $( cartItem ).find('.media-image').append('<div class="store-icon-container ui-text-primary-color width-30-hard"><span class="store-icon ' + data.item.parentProduct.icon + '"></span></div>');
                        }

                        $('.cart-item-cost', cartItem).text(data.item.qty + ' @ ' + cost + ' ea.');
                        $('.cart-item-title', cartItem).text(_this._currentBundle.title);

                        if ( data.item.fieldData.length ) {
                            var categories = [];

                            for ( var ind in data.item.fieldData ) {
                                cartItem.attr('data-attr'+data.item.fieldData[ind]['id'], data.item.fieldData[ind]['data']);
                                categories.push(data.item.fieldData[ind]['text'] + ' : ' + data.item.fieldData[ind]['data']);
                            }
                            $('.cart-item-description', cartItem).html(categories.join('<br/>'));
                        }

                        var msg = 'Your item has been successfully added to the cart.',
                            state = "success";

                        cartItem.attr('data-id', data.item.id);
                        cartItem.attr('data-bundleid', data.item.bundle);
                        cartItem.attr('data-qty', data.item.qty);

                        if ( _this.activeEdit ) {
                            $('.cart-item-tile[data-id="'+_this.activeEdit.attr('data-id')+'"]').replaceWith(cartItem);
                        } else {
                            if ( $('.cart-item-tile[data-id="'+data.item.id+'"]').length ) {
                                $('.cart-item-tile[data-id="'+data.item.id+'"]').replaceWith(cartItem);
                            } else {
                                $('.cart-contents').prepend(cartItem);
                            }
                        }

                        if ( data.cartCount === '1' ) {
                            $('.cart-status').text('1 Item');
                        } else {
                            $('.cart-status').text(data.cartCount + ' Items');
                        }

                        $('.cart-total').text('Total: ' + _this.formatFormCurrency(data.cartTotal));

                        _this.productDetailsModal.data('qg_modal').closeModal();
                        _this._currentProduct = {};
                        _this._currentBundle = {};

                        if ( data.message ) {
                            msg = data.message;

                            if ( data.message.match("error") ) {
                                state = "error";
                            }
                        }

                        _this.updateCartContainers(data.cartCount);
                        _this.displayPopupCartMessage(msg, state);
                    } else if ( data.errors ) {
                        _this.displayCartMessage(data.errors.join('<br/>'), 'error');
                    } else {
                            _this.displayCartMessage('An error has occurred. Please try again.', 'error');
                    }

                    // reset processing flag
                    _this.processing = false;
                },
                failure : function(){
                    _this.displayCartMessage('An error has occurred. Please try again.', 'error');

                    // reset processing flag
                    _this.processing = false;
                }
                });
        }
    },

    deleteCartItem : function(id){
        var _this = this;
        $('.ui-message').remove();

        var postString = "&action=delete-from-cart&productId=" + id;

        if ( window.location.href.indexOf('register') != -1 ) {
            postString += "&fromReg=1";
        }

        $.fn.qpost({
            url : url('store_checkout', [$('input[name="form"]').val()]),
            csrf : true,
            type : "POST",
            data : postString,
            dataType : "json",
            success : function(data){
                if ( data && data.success ) {
                    if ( $('.cart-item-tile[data-id="'+id+'"]').length ) {
                        $('.cart-item-tile[data-id="'+id+'"]').fadeOut('fast', function() {
                            $('.cart-item-tile[data-id="'+id+'"]').remove();

                            if ( $('.cart-status').length ) {
                                if ( data.cartCount <= 0 ) {
                                    $('.cart-status').text('Empty');
                                } else if ( data.cartCount === '1' ) {
                                    $('.cart-status').text('1 Item');
                                } else {
                                    $('.cart-status').text(data.cartCount + ' Items');
                                }
                            }

                            if ( $('.shopping-cart-table').length ) {
                                $('.subtotal-amount').text(_this.currencyFormat(data.cartTotal));
                                _this.updateTotals();

                                if ( $('.shopping-cart-table tbody').children().length <= 0 ) {
                                    // they emptied their entire cart.
                                    if ( window.location.href.indexOf('register') === -1 ) {
                                        window.location.href = window.location.href.substr(0, window.location.href.indexOf('checkout'));
                                    } else {
                                        $('.shopping-cart-table, .update-cart').fadeOut('fast', function() {
                                            $('.shopping-cart-table, .update-cart').remove();
                                        });
                                    }
                                }
                            } else {
                                $('.cart-total').text('Total: ' + _this.currencyFormat(data.cartTotal));
                            }
                        });
                    }

                    if ( data.cartCount < 1 && $('#choose-shipping-options').length ) {
                        $('#choose-shipping-options').closest('.timeline-item').remove();
                    }
                } else if ( data.errors ) {
                    _this.displayMessage(data.errors.join('<br/>'), 'error');
                } else {
                        _this.displayMessage('An error has occurred. Please try again.', 'error');
                }
                _this.updateCartContainers(data.cartCount);
            },
            failure : function(){
                _this.displayMessage('An error has occurred. Please try again.', 'error');
                }
        });
    },

    updateCartContainers : function(count){
        var $cartEmptyMsg = $('.shopping-cart-empty'),
            $cartTiles = $('.shopping-cart-tiles'),
            $cartFooter = $('.cart-footer');

        if ( count >= 1 ) {
            $cartEmptyMsg.addClass('hide-content').text('No Items');
            $cartTiles.removeClass('hide-content');
            $cartFooter.removeClass('hide-content');
        } else {
            $cartEmptyMsg.removeClass('hide-content').text();
            $cartTiles.addClass('hide-content');
            $cartFooter.addClass('hide-content');
        }
    },

    updateCart : function(){
        var postString = "action=refresh-cart"
        var edited = false;
        var _this = this;

        $('.shopping-cart-table tbody').children().each(function(){
            if (!$(this).find('.product-qty').val()) {
                $(this).find('.product-qty').val(0);
            }

            if ( parseInt($(this).attr('data-qty')) != $(this).find('.product-qty').val() ) {
                edited = true;
            }

            postString += "&product["+$(this).attr('data-id')+"]=" + $(this).find('.product-qty').val();
        });

        if ( window.location.href.indexOf('register') != -1 ) {
            postString += "&fromReg=1";
        }

        if (edited) {
            $.fn.qpost({
                url : url('store_checkout', [$('input[name="form"]').val()]),
                csrf : true,
                type : "POST",
                data : postString,
                dataType : "json",
                success : function(data){
                    if ( data && data.cartTable ) {
                        $('.shopping-cart-table').replaceWith(data.cartTable);

                        if ( $('.shopping-cart-table tbody').children().length <= 0 ) {
                            // they emptied their entire cart.
                            window.location.href = window.location.href.substr(0, window.location.href.indexOf('checkout'));
                        } else {
                            $('.shopping-cart-table').find('.ui-numeric-text').numericInput();

                            var msg = "Your cart has been successfully updated! ";
                            var state = "success";

                            if ( $('.product-adjusted').length ) {
                                msg += "<br/>Due to stock levels, some items in your cart have been automatically adjusted.";
                            }

                            if ( $('.product-unavailable').length ) {
                                msg += "<br/>Due to some products being out of stock, some items in your cart have been automatically removed.";
                            }

                            if ( msg ) {
                                _this.displayMessage(msg, 'success');
                            }

                            _this.updateTotals();
                        }
                    } else if ( data.errors ) {
                        _this.displayMessage(data.errors.join('<br/>'), 'error');
                    } else {
                            _this.displayMessage('An error has occurred. Please try again.', 'error');
                    }
                    UI.truncate( '.cart-item-tile .product-description', 150 );
                },
                failure : function(){
                    _this.displayMessage('An error has occurred. Please try again.', 'error');
                    }
            });
        }
    },

    displayMessage : function(message, state){
        Message.target = '.event-content';
        Message.setMessage(message);
        Message.type = state;
        Message.postMessage();
    },

    displayPopupCartMessage : function(message, state){
        Message.target = '.shopping-cart-tiles';
        Message.setMessage(message);
        Message.type = state;
        Message.scrollToMessage = false;

        if ( state === 'error' ){
            Message.postMessage();
        }

        UI.scrollToElement('.popup-shopping-cart', 800, 'html, body', 60);

        setTimeout(function() {
            $('.popup-shopping-cart .ui-popup-trigger').trigger('click');
            setTimeout(function () {
                $('.product-tile.ui-highlight-color').removeClass('ui-highlight-color');
            }, 1200);
        }, 800);
    },

    displayCartMessage : function(message, state){
        Message.target = '.item-popup';
        Message.setMessage(message);
        Message.type = state;
        Message.postMessage();
    },

    // formatting currency in a span
    currencyFormat : function(amount){
        return currencyFormat(amount, QGIV.Form.currency.format);
    },

    // formatting currency without a span
    formatFormCurrency : function(amount){
        return formatFormCurrency(amount);
    },

    // gets the base price
    getBasePrice : function(product) {
        var price_fixed = product.price_fixed,
            price_low = product.price_low,
            price_high = product.price_high,
            price_final = 0;

        if (!price_fixed && !price_low && !price_high) {
            // this is an inventory item pricing, not a base product
            price_fixed = product.cost;
        }

        // if cost ends in '.00', hide the cents
        if (price_fixed > 0) {
            price_fixed = formatFormCurrency(price_fixed, true);

            price_final = price_fixed;
        } else if (price_high > 0) {
            price_low = formatFormCurrency(price_low, true);
            price_high = formatFormCurrency(price_high, true);

            price_final = price_low + " - " + price_high;
        }

        return price_final;
    },

    initDonationSearch : function() {
        var _this = this;

        _this.searchField = '#search-donation-recipients';
        _this.searchResults = '#search-donation-recipients-results';

        _this.searchSettings = {
            form : $('input[name="form"]').val(),
            filters : {
                search_term : $( _this.searchField ).val(),
                search_category : 'purchase_entity',
                template: 'donation_recipients_search_results'
            },
            autoSearch : false,
            operation : $('input[name="search_type"]').val(),
            container : '.js-donation-recipient-search',
            searchInput : _this.searchField,
            resultContainer : _this.searchResults,
            request : url('event_search', [$('input[name="form"]').val()]),
            saveSettings : false,
            onSuccess : function( data ){
                var $columns = $(_this.searchResults).find('.grid-unit'),
                    participantLabel = $(_this.searchResults).attr('data-participant-label') + 's',
                    teamLabel = $(_this.searchResults).attr('data-team-label') + 's';

                noResultsCheck( data );

                $('.js-registration-result-divider').text( participantLabel );
                $('.js-team-result-divider').text( teamLabel );

                $('.js-donation-recipient-search').find('.clear-search-button').removeClass('hide-content');

                if ( $columns.length == 1 ) {
                    $columns.removeClass('six-twelfths').addClass('whole');
                }
            }
        }

        var noResultsCheck = function( data ) {
            if ( ! data.entities ) {
                $(_this.searchResults).html('<div class="grid-unit whole text-center"><div class="padding-1x">No Results</div></div>');
            }
        };

        $('#donor-recipient-search-form').on('submit', function(e) {
            e.preventDefault();
        });

        $(_this.searchResults).on('click', '.js-select-donation-recipient', function() {
            var $this = $(this),
                entityId = $this.attr('data-entity-id'),
                entityName = $this.attr('data-entity-name'),
                entityType = $this.attr('data-entity-type'),
                $entityAvatar = $this.find('.mini-avatar'),
                viewName;

            // Populate the message with the new name and avatar
            $('.js-donation-recipient-container')
                .find('.js-entity-name').text( entityName ).end()
                .find('.donation-recipient-avatar').html( $entityAvatar.html() ).end()
                .find('.js-has-donation-recipient').removeClass('hide-content').end()
                .find('.js-no-donation-recipient').addClass('hide-content');

            // Update form data for post
            switch (entityType) {
                case 'registration':
                    viewName = 'account_donation';
                    break;
                case 'team':
                    viewName = 'team_donation';
                    break;
                case 'classification':
                    viewName = 'classification_donation';
                    break;
                default:
                    viewName = 'event_donation';
            }

            // reset our classification
            $('input[name="classification"]').val('');

            // check if we're selecting a classification and populate correctly
            // else, just set the correct entity ID
            if ( entityType == 'classification' ){
                $('input[name="entity"]').val($('#form-id').val());
                $('input[name="classification"]').val(entityId);
            } else {
                $('input[name="entity"]').val( entityId );
            }

            $('input[name="donation_type"]').val( viewName );

            // Close the search modal
            _this.donationRecipientModal.closeModal();
        });

        $('.js-undo-donation-recipient').on('click', function(e) {
            e.preventDefault();

            $('.js-donation-recipient-container')
                .find('.js-has-donation-recipient').addClass('hide-content').end()
                .find('.js-no-donation-recipient').removeClass('hide-content');

            // Update form data for post
            $('input[name="entity"]').val( $('input[name="form"]').val() );
            $('input[name="donation_type"]').val( 'event_donation' );
            $('input[name="classification"]').val('');
        });

        $('.clear-search-button').on('click', function() {
            $(this).addClass('hide-content');

            _this.resetEntitySearchModal();
        });

        //instantiate the search
        _this.donationRecipientSearch = new SystemSearch( _this.searchSettings );
    },

    resetEntitySearchModal : function() {
        var _this = this;

        // Reset the search field and results
        $(_this.searchField).val('').blur();
        setTimeout(function() {
            $(_this.searchResults).find('.grid-unit').remove();
        }, 300);
    }
}

$(document).ready(function(){
    var _store = new Store();
    // add this to the global object so that we can call it in the event builder re-load
    QGIV.Store = _store;
});
